import { OpacitySlide } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { usePensionNameValue } from "@/shared/client";
import { useGetCommon, type AboutInfoResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { removeHtmlTags } from "@/utils";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useInView } from "react-intersection-observer";
import { TextBanner } from "../textBanner";

export const AboutSection = () => {
    const { data } = useGetCommon<AboutInfoResponse>({ section: "about" });
    const { data: introData } = useGetCommon<any>({ section: "about_intro" });
    const pensionName = usePensionNameValue();
    const { ref, inView } = useInView({ threshold: 0.9, triggerOnce: true, delay: 0.3 });
    const { MEDIAS } = useDesignMaxTheme();
    const { isLaptop, isMobile } = MEDIAS();

    const engFontSize = isLaptop ? 32 : 48;
    return data && introData ? (
        <Center ref={ref} w="100%" h="100dvh">
            <OpacitySlide isControls={false} isScale={false} imgList={data.imgList} ease="easeOut" opacityTime={0.6}>
                <TextBanner inView={inView}>
                    <Box textAlign="center">
                        <Text {...FONT("notoSerif", isMobile ? 14 : 20, 500)}>{pensionName}</Text>
                        <Text {...FONT("cormorant", isMobile ? 24 : engFontSize, 700, 1.2)}>
                            WELCOME TO OUR PENSIONS
                        </Text>
                    </Box>
                    <Box textAlign="center">
                        <Text {...FONT("pretendard", isMobile ? 14 : 16, 300)}>{introData.firstLine}</Text>
                        <Text {...FONT("pretendard", isMobile ? 14 : 16, 300)}>
                            {introData.textArea ? removeHtmlTags(introData.textArea, "<br>").cleanText : ""}
                        </Text>
                    </Box>
                </TextBanner>
            </OpacitySlide>
        </Center>
    ) : (
        <Center w="100%" h="100vh">
            <Spinner />
        </Center>
    );
};
